import { fetchApi } from '@/std/api/fetchApi';
import { registrosSchema } from '@/std/schema';
import { ProdutoOrigemSchema } from '../types/ProdutoOrigem';

type ApiProdutoOrigemGetParams = {
    pesquisar?: string;
};

const schema = registrosSchema(ProdutoOrigemSchema);

export function apiProdutoOrigemGet(params?: ApiProdutoOrigemGetParams) {
    return fetchApi({
        endpoint: 'ProdutoOrigem/ProdutoOrigem',
        method: 'get',
        params,
        schema,
    });
}
